import React from "react"
import * as styles from './Quote.module.css'

export function Quote ({ title = undefined, text }) {
  return (
    <div className={styles.component}>
      <blockquote className={styles.blockquote}>
        {title && <p><strong className={styles.heading}>{ title }</strong></p>}
        { text }
      </blockquote>
    </div>
  )
}
